"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Response = exports.nullBodyStatuses = void 0;
var Headers_1 = require("../../../shared/internal/HTTPRequestConfig/Headers");
exports.nullBodyStatuses = [101, 103, 204, 205, 304];
var Response = /** @class */ (function () {
    function Response(params) {
        var rawHeaders = params.rawHeaders, reqConfig = params.reqConfig, response = params.response;
        this.requestBody = '';
        this.requestHeaders = reqConfig.headers;
        this.requestMethod = reqConfig.method;
        this.responseHeaders = new Headers_1.Headers((typeof rawHeaders === 'string' ? parseResponseHeaders(rawHeaders) : Array.from(rawHeaders.entries())) || []);
        this.response = response;
        this.responseStatusCode = params.statusCode;
        this.responseType = reqConfig.responseType || 'string';
    }
    Object.defineProperty(Response.prototype, "responseBody", {
        get: function () {
            return this.parsedBody;
        },
        enumerable: false,
        configurable: true
    });
    Response.prototype.compileBody = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (exports.nullBodyStatuses.includes(this.responseStatusCode)) {
                            return [2 /*return*/];
                        }
                        _a = this.responseType;
                        switch (_a) {
                            case 'json': return [3 /*break*/, 1];
                            case 'binary': return [3 /*break*/, 3];
                        }
                        return [3 /*break*/, 5];
                    case 1:
                        _b = this;
                        return [4 /*yield*/, this.response.json()];
                    case 2:
                        _b.parsedBody = (_e.sent());
                        return [3 /*break*/, 7];
                    case 3:
                        _c = this;
                        return [4 /*yield*/, this.response.arrayBuffer()];
                    case 4:
                        _c.parsedBody = (_e.sent());
                        return [3 /*break*/, 7];
                    case 5:
                        _d = this;
                        return [4 /*yield*/, this.response.text()];
                    case 6:
                        _d.parsedBody = (_e.sent());
                        _e.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    Response.prototype.complete = function () {
        return {
            requestURI: {},
            requestMethod: this.requestMethod,
            requestHeaders: this.requestHeaders.toArray(),
            requestBody: this.requestBody,
            responseStatusCode: this.responseStatusCode,
            responseHeaders: this.responseHeaders.toArray(),
            responseBody: this.parsedBody,
        };
    };
    return Response;
}());
exports.Response = Response;
var withoutEmpty = function (header) { return header.trim().length > 0; };
var nameWithValue = function (header) {
    var index = header.indexOf(':');
    return [header.slice(0, index).trim().toLowerCase(), header.slice(index + 1).trim()];
};
function parseResponseHeaders(str) {
    return str.split('\r\n').filter(withoutEmpty).map(nameWithValue);
}
//# sourceMappingURL=Response.js.map